<div class="ui-stat-card">
  <div class="ui-stat-card__icon ui-stat-card__icon--{{ tone() }}" aria-hidden="true">
    <ui-icon [name]="icon()" />
  </div>
  <div class="ui-stat-card__content">
    <span class="ui-stat-card__value">{{ value() }}</span>
    <span class="ui-stat-card__label">{{ label() }}</span>
    @if (description()) {
      <span class="ui-stat-card__description">{{ description() }}</span>
    }
  </div>
</div>
